import { render, staticRenderFns } from "./addGrabAndGo.vue?vue&type=template&id=4e9bf9f4&"
import script from "./addGrabAndGo.vue?vue&type=script&lang=js&"
export * from "./addGrabAndGo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports